  (function (doc, win) {
  	var docEl = doc.documentElement,
  		resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
  		recalc = function () {
  			var clientWidth = docEl.clientWidth;
  			if (!clientWidth) {
  				return;
  			}
  			//获取浏览器navigator对象的userAgent属性（浏览器用于HTTP请求的用户代理头的值）
  			var info = navigator.userAgent;
  			//通过正则表达式的test方法判断是否包含“Mobile”字符串
  			var isPhone = /mobile/i.test(info);
  			if (isPhone) {
  				docEl.style.fontSize = clientWidth * 75 / 750 + 'px';
  				document
  					.querySelector("#app")
  					.setAttribute("style", "height:100vh;");
  			} else {
  				docEl.style.fontSize = '37.5px'
  				// document.querySelector("#app").setAttribute("style", "height:100vh;max-width: 414PX;margin-left: auto;margin-right: auto;");
  			}
  		};

  	if (!doc.addEventListener) {
  		return;
  	}
  	win.addEventListener(resizeEvt, recalc, false);
  	doc.addEventListener('DOMContentLoaded', recalc, false);
  })(document, window);
  //   postcss-pxtorem